import { Search } from "../api/searchService";
import { SearchRecord } from "./advancedSearch.types";

export interface SearchResponse {
  status?: number;
  data?: { Records?: SearchRecord[]; TotalRecords?: number };
}

/** `Search` with a request typed as the object it builds, not the JS defaults. */
export const searchRecords = Search as unknown as (
  dispatch: unknown,
  successMessage: string,
  request: Record<string, unknown>
) => Promise<SearchResponse | undefined>;
